import type { Optional } from '@festina-life/core'
import { Field, Label } from '@headlessui/react'
import type { ComponentProps, JSX } from 'react'

import { RawCheckbox } from '../../../../forms/checkbox/RawCheckbox'
import { typographyStyles } from '../../../../structure/typography/styles'

type Props = ComponentProps<typeof RawCheckbox> & {
  label: Optional<string | number | JSX.Element>
}

export const FilterCheckbox = ({ label, ...props }: Props) => (
  <Field className="flex gap-x-2 items-center">
    <RawCheckbox {...props} />
    <Label
      htmlFor={props.id}
      className={`${typographyStyles({ weight: 'semibold' })}`}
    >
      {label}
    </Label>
  </Field>
)
